// import React from "react";

// export const Success = () => {
//   return (
//     <div className="flex justify-center px-4">
//       <div className="max-w-lg w-full text-center space-y-6">
//         {/* Success Icon */}
//         <div className="flex items-center justify-center">
//           <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center text-white text-4xl">
//             ✓
//           </div>
//         </div>

//         {/* Thank You Message */}
//         <div className="text-xl font-semibold">
//           Thank you for your purchase! Your transaction has been completed successfully.
//         </div>

//         {/* Receipt Message */}
//         <div className="text-sm space-y-2">
//           <p>A copy of the payment receipt will be emailed to you shortly!</p>
//           <p>
//             You can also view the receipt{" "}
//             <a href="javascript(void);" className="text-green-400 underline hover:text-green-300">
//               here
//             </a>.
//           </p>
//         </div>

//         {/* Confirmation Number */}
//         <div className="text-sm">
//           <span className="font-bold ">Your confirmation number:</span> <span className="text-green-400">HUKY1234</span>
//         </div>

//         {/* Footer Message */}
//         <div className="text-sm">
//           <p>Happy Learning!!!</p>
//           <p>Team Smiklearn</p>
//         </div>
//       </div>
//     </div>
//   );
// };

import React from "react";
import { useSelector } from "react-redux";

export const Success = () => {
  const { user } = useSelector((state) => state.users);
  
  const { data } = useSelector((state) => state.cart?.data);

  const getPaymentMethodText = () => {
    if (!data.paymentMethod) return "Payment completed successfully";
    
    switch(data?.paymentMethod?.method) {
      case 'card':
        return `Paid via ${data?.paymentMethod?.card?.network || ''} card ending with ${data?.paymentMethod?.card?.last4 || '****'}`;
      case 'upi':
        return `Paid via UPI (${data?.paymentMethod?.vpa || 'UPI payment'})`;
      case 'netbanking':
        return `Paid via Net Banking (${data?.paymentMethod?.bank || 'bank transfer'})`;
      case 'wallet':
        return `Paid via ${data?.paymentMethod?.wallet || 'digital wallet'}`;
      default:
        return "Payment completed successfully";
    }
  };

  const getConfirmationNumber = () => {
    return  data?.paymentMethod?.paymentId || 'HUKY' + Math.floor(1000 + Math.random() * 9000);
  };

  return (
    <div className="flex justify-center px-4 py-8">
      <div className="max-w-lg w-full text-center space-y-6 bg-white rounded-lg shadow-md p-6">
        {/* Success Icon */}
        <div className="flex items-center justify-center">
          <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center text-white text-4xl animate-bounce">
            ✓
          </div>
        </div>

        {/* Thank You Message */}
        <div className="space-y-4">
          <h1 className="text-2xl font-bold text-gray-800">Order Confirmed!</h1>
          <p className="text-lg text-gray-600">
            Thank you, {user?.userName || 'Customer'}, for your purchase!
          </p>
        </div>

        {/* Payment Details */}
        <div className="bg-gray-50 p-4 rounded-lg text-left space-y-2">
          <div className="flex justify-between">
            <span className="font-medium">Payment Method:</span>
            <span>{getPaymentMethodText()}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium">Confirmation Number:</span>
            <span className="text-green-600 font-semibold">
              {getConfirmationNumber()}
            </span>
          </div>
          {data?.paymentMethod?.amount && (
            <div className="flex justify-between">
              <span className="font-medium">Amount Paid:</span>
              <span className="font-semibold">
                ₹{(data?.paymentMethod?.amount / 100).toFixed(2)}
              </span>
            </div>
          )}
        </div>

        {/* Receipt Message */}
        <div className="text-sm space-y-2 text-gray-600">
          <p>A detailed receipt has been sent to {user?.email || 'your email'}.</p>
          <p>
            You can also access your courses from your{" "}
            <a 
              href="/dashboard" 
              className="text-green-500 underline hover:text-green-400 font-medium"
            >
              dashboard
            </a>.
          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-4">
          <a
            href="/dashboard"
            className="inline-block bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-6 rounded-lg transition duration-200"
          >
            Start Learning Now
          </a>
        </div>

        {/* Footer Message */}
        <div className="pt-4 text-sm text-gray-500">
          <p>Need help? Contact us at support@yslearn.in</p>
          <p className="mt-1">Happy Learning! 🚀</p>
        </div>
      </div>
    </div>
  );
};
